import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.css";
import Nav from "./nav";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Badge
} from "reactstrap";
import Map from "./Map";
export default class PoemDescriptionDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: true };
    this.close = this.close.bind(this);
  }

  close() {
    this.setState({ open: false });
    this.props.dialogClosed();
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.state.open}>
          <ModalHeader toggle={this.close}>{this.props.poemTitle}</ModalHeader>
          <ModalBody>{this.props.description}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.close}>
              غلق
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PoemDescriptionDialog.js